module.exports = ".confirm-password-content {\n  margin-top: 170px; }\n"